import { Component, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { WButtonBaseDirective } from './w-button.base.directive';

@Component({
    selector: 'w-button-download',
    encapsulation: ViewEncapsulation.None,
    template: `
    <i icon="download"></i><span [innerHTML]="label"></span>
    `,
    styleUrls: ['w-button-download.component.scss'],
    host: {
        class:'b-button-download',
        '[class.b-button--is-disabled]': 'disabled',
    },
    standalone: false
})
/*
@id w-button-download
@name w-button-download
@status release
@description specific download button
*/
export class WButtonDownloadComponent extends WButtonBaseDirective {
    constructor(protected elementRef: ElementRef) { super(); }
}
